import React from 'react';

import { Link } from 'react-router-dom';

import Layout from '../../../containers/Layout';
import BillPaymentsTable from '../../../components/BillPaymentsTable';
import Pagination from '../../../components/Pagination';

import BillPaymentService from '../../../services/BillPaymentService';
import usePagination from '../../../hooks/usePagination';

export default function BillPaymentPage() {
  const {
    currentPage,
    switchToPage,
    pageTotal,
    isFetching,
    data: billPayments,
  } = usePagination({
    queryKey: ['billPayments'],
    queryFn: BillPaymentService.getBillPayments,
    perPage: 25,
  });

  return (
    <Layout>
      <div className="flex">
        {/* Content area */}
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
          <main className="grow">
            <div className="px-4 sm:px-6 lg:px-8 py-8 pb-10 w-full max-w-9xl mx-auto">
              {/* Page header */}
              <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* Left: Title */}
                <div className="mb-4 sm:mb-0">
                  <h1 className="text-2xl md:text-3xl text-slate-800 dark:text-slate-100 font-bold">
                    Bill Payments
                  </h1>
                </div>

                {/* Right: Actions */}
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                  {/* Add vendor button */}
                  <Link
                    to="/bill-payments/new"
                    className="btn bg-indigo-500 hover:bg-indigo-600 text-white"
                  >
                    <svg
                      className="w-4 h-4 fill-current opacity-50 shrink-0"
                      viewBox="0 0 16 16"
                    >
                      <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                    </svg>
                    <span className="hidden xs:block ml-2">
                      Create Bill Payment
                    </span>
                  </Link>
                </div>
              </div>

              <BillPaymentsTable
                isFetching={isFetching}
                noTitle
                billPayments={billPayments?.items}
                isBillPaymentsPage
              />

              <Pagination
                pageTotal={pageTotal}
                switchToPage={switchToPage}
                currentPage={currentPage}
              />
            </div>
          </main>
        </div>
      </div>
    </Layout>
  );
}
